import {
  TableBody,
  TableCell,
  TableRow,
} from "@windmill/react-ui";
import CheckBox from "components/form/CheckBox";
import DeleteModal from "components/modal/DeleteModal";
import DeleteButton from "components/table/DeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";
import { can } from "utils/permissions";

const SubscriberTable = ({
  isCheck,
  setIsCheck,
  data,
  isLoading,
  setIsLoading,
  adminprevilegesList,
  fullAccess,
}) => {
  const { handleModalOpen, serviceId } = useToggleDrawer();

  const beforeHandleModalOpen = (id, email) => {
    handleModalOpen(id, email);
  };

  return (
    <>
      {isCheck?.length < 1 && (
        <DeleteModal
          id={serviceId}
          title={data?.email}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      )}

      <TableBody>
        {data?.map((item, i) => (
          <TableRow key={i + 1}>
            <TableCell>
              <CheckBox
                id={item.id}
                name={item.email}
                type="checkbox"
                isChecked={isCheck?.includes(item.id)}
                setIsCheck={setIsCheck}
              />
            </TableCell>
            <TableCell>
              <div className="flex items-center">
                <h2 className="text-sm font-medium">{item.id}</h2>
              </div>
            </TableCell>
            <TableCell>
              <span className="text-sm font-medium">{item.email}</span>
            </TableCell>
            <TableCell>
              {can(adminprevilegesList, "delete_subscriber", fullAccess) && (
                <DeleteButton
                  id={item.id}
                  name={item.email}
                  title={item.email}
                  isCheck={isCheck}
                  handleModalOpen={beforeHandleModalOpen}
                />
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default SubscriberTable;
